import type { DBTypes } from '@openphone/dexie-database/types'
import { makeAutoObservable, toJS } from 'mobx'

import type { Model } from '@src/service/model/base'

export type RawWorkflowFilterDefinition = DBTypes.WorkflowFilterDefinitionRow

export default class WorkflowFilterDefinitionModel implements Model {
  private raw: RawWorkflowFilterDefinition

  get id() {
    return this.raw.id
  }

  get version() {
    return this.raw.version
  }

  get displayNameId() {
    return this.raw.displayNameId
  }

  get category() {
    return this.raw.category
  }

  get handler() {
    return this.raw.handler
  }

  get input() {
    return this.raw.input
  }

  get output() {
    return this.raw.output
  }

  get requiredCapabilities() {
    return this.raw.requiredCapabilities
  }

  get supportLevel() {
    return this.raw.supportLevel
  }

  constructor(attrs: RawWorkflowFilterDefinition) {
    this.raw = attrs

    makeAutoObservable<this>(this)
  }

  deserialize(json: RawWorkflowFilterDefinition): this {
    this.raw = json
    return this
  }

  serialize(): RawWorkflowFilterDefinition {
    return toJS(this.raw)
  }
}
